export const ImageSrc = (imageId, imageExt, size) => `http://prod-service-devant-storage.s3-website.us-east-1.amazonaws.com/images/${imageId}@${size}x${size}${imageExt}`
